import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import mapStateToProps from './query.tsx';
import { IssueDropMenu } from './view.tsx';

export default connect(mapStateToProps, null, null, { forwardRef: true })(IssueDropMenu);
